module.exports = __webpack_public_path__ + "img/undraw_shared_workspace_hwky.d883cac1.svg";